import styled from 'styled-components';
import { BLACK_60 } from '@gr-monorepo/common/public/ui/constants/colors';
import { SecondaryButton } from '@gr-monorepo/common/public/ui/Buttons';
import { H3 } from 'features/shared/ui/Heading';

export const CircleButton = styled.div`
  width: auto;
  background: var(--font-color);
  color: white;
  border-radius: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const FeedbackModalContent = styled.div<{ $isSuccess?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 640px;
  max-width: calc(100vw - 96px);
  height: ${({ $isSuccess }) => ($isSuccess ? '600px' : 'auto')};
  max-height: 600px;
  padding: 48px 40px 32px;
  box-sizing: border-box;
  overflow: hidden;
`;

export const FeedbackModalTitle = styled(H3)`
  margin: 0 0 24px;
  padding: 0 32px 0 0;
  text-align: center;
`;

export const FeedbackFormScroll = styled.div<{ $isSuccess?: boolean }>`
  flex: 1;
  min-height: 0;
  overflow: ${({ $isSuccess }) => ($isSuccess ? 'hidden' : 'auto')};
  box-sizing: border-box;
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const FieldFlexRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const HintText = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 20px;
  color: ${BLACK_60};
`;

export const PrivacyText = styled(HintText)`
  text-align: center;
`;

export const SuccessWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  > * {
    flex: 0 0 auto;
  }
`;

export const PolicyLink = styled.a`
  color: var(--primary-base);
  text-decoration: underline;
  outline: none;
  &:active,
  &:focus,
  &:hover,
  &:visited {
    color: var(--primary-base);
    text-decoration: underline;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  padding: 10px 16px 10px 12px;
`;

export const FeedbackButtonText = styled.p`
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  margin: 0;
`;

export const AttachButton = styled(SecondaryButton)`
  svg {
    display: block;
    flex-shrink: 0;
    width: 20px;
    height: 20px;

    path {
      fill: currentColor;
    }
  }
`;